import React from "react";

/* eslint-disable @typescript-eslint/ban-types */
interface AccountInfoPanelProps {
  header: String;
  text: string;
}
/* eslint-enable @typescript-eslint/ban-types */

const AccountInfoPanel: React.FC<AccountInfoPanelProps> = ({
  header,
  text,
}) => {
  return (
    <div className="dark-panel mt-4 flex flex-col justify-start rounded-xl">
      <div className="flex flex-col justify-between px-6 md:flex-row lg:px-12 xl:px-20 2xl:px-24">
        <h1 className="light-text py-4 font-code font-bold md:text-2xl lg:text-4xl">
          {header}
        </h1>
        <h1 className="pr light-text py-4 font-code md:text-2xl lg:text-4xl">
          {text.toUpperCase()}
        </h1>
      </div>
    </div>
  );
};

export default AccountInfoPanel;
